module.exports = {"310230101":"城桥镇","310230102":"堡镇","310230103":"新河镇","310230104":"庙镇","310230106":"竖新镇","310230107":"向化镇","310230109":"三星镇","310230113":"港沿镇","310230114":"中兴镇","310230115":"陈家镇","310230116":"绿华镇","310230118":"港西镇","310230119":"建设镇","310230121":"新海镇","310230122":"东平镇","310230123":"长兴镇","310230201":"新村乡","310230203":"横沙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310230.json
// module id = 762
// module chunks = 0